import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "d-flex mt-16" }
const _hoisted_3 = { class: "primary--text" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "d-flex justify-center align-center month-heading-row" }
const _hoisted_6 = { class: "ma-0" }
const _hoisted_7 = { class: "primary--text" }
const _hoisted_8 = { class: "pa-7" }
const _hoisted_9 = { class: "text-center pr-5 event-date-wrapper" }
const _hoisted_10 = { class: "caption" }
const _hoisted_11 = { class: "text-no-wrap" }
const _hoisted_12 = { style: {"white-space":"pre-wrap","user-select":"none"} }
const _hoisted_13 = { style: {"line-height":"38px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_calendar = _resolveComponent("v-calendar")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_scroll = _resolveDirective("scroll")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_app_bar, {
        color: "primary",
        flat: "",
        app: "",
        dark: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            style: {"position":"absolute"},
            icon: "",
            to: '/'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_app_bar_title, { style: {"min-width":"fit-content"} }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('settings.eventCalendar')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer)
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        tile: "",
        class: "overflow-hidden no-scroll-bar pb-14",
        elevation: "0"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_btn, {
              onClick: _ctx.toPrevMonth,
              variant: "text",
              class: "no-background-hover mt-3 pl-0",
              color: "primary",
              dark: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("mdi-chevron-left", -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t('date.previousMonth')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_v_app_bar_title, null, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCalendar = !_ctx.isCalendar))
                }, [
                  _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.year), 1),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.month), 1),
                    (_ctx.isCalendar)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          class: "month-calendar-toggle-icon",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("mdi-chevron-down", -1)
                          ]))]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          class: "month-calendar-toggle-icon",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode("mdi-chevron-up", -1)
                          ]))]),
                          _: 1
                        }))
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              onClick: _ctx.toNextMonth,
              variant: "text",
              class: "no-background-hover mt-3 pr-0",
              color: "primary"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.$t('date.nextMonth')), 1),
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("mdi-chevron-right", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode(_component_v_expand_transition, null, {
            default: _withCtx(() => [
              (_ctx.isCalendar)
                ? (_openBlock(), _createBlock(_component_v_sheet, {
                    key: 0,
                    class: "",
                    height: "400"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_calendar, {
                        modelValue: _ctx.now,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.now) = $event)),
                        color: "primary",
                        "day-format": (d) => {
                const date = new Date(d.date);
                const day = date.getDate();
                const month = date.getMonth() + 1;
                return day === 1 ? `1 / ${month}` : day.toString();
              },
                        "month-format": () => '',
                        "onClick:day": _cache[2] || (_cache[2] = (_event, value) => _ctx.viewDay(value))
                      }, {
                        day: _withCtx(({ date }) => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEventNum(date), (e) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: e.yearlyEventId,
                              class: "d-flex justify-center"
                            }, [...(_cache[8] || (_cache[8] = [
                              _createElementVNode("div", { class: "event_num ma-1" }, null, -1)
                            ]))]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "day-format"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [
            [_vShow, !_ctx.isCalendar]
          ]),
          _createVNode(_component_v_sheet, {
            id: "scrolling-techniques-2",
            class: "overflow-y-auto no-scroll-bar",
            "max-height": "100vh",
            elevation: "0"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (e, index) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: e.yearlyEventId + index,
                  class: "plan-wrapper ma-1 pa-2 d-flex",
                  style: {"border-color":"#32c5ff"}
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.dayFormat(e.date)), 1),
                    _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.dateFormat(e.date)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(e.eventName), 1)
                  ]),
                  _createVNode(_component_v_spacer)
                ])), [
                  [_directive_scroll, _ctx.onScroll, "#scrolling-techniques-2"]
                ])
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}